export default __webpack_public_path__ + "static/media/wagerTimeIcon.69af2dc0.svg";